// import { ObjectId } from "bson";


var ObjectId = function () {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
};


/**
 * Get a new object ID
 * @returns string
 */
export const ObjectID = () => {
  return ObjectId().toString();
}
